export const NAME = 'spiralBindingMachines';